import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Button.less';

export const BUTTON_STYLE = {
    NORMAL: '',
    LINK: 'vx_btn-link',
    UNSTYLED: 'unstyled',
    PP_PRIMARY: 'vx_btn', // Primary button
    PP_SECONDARY: 'vx_btn-secondary' // Secondary button
};

export const BUTTON_TYPE = {
    BUTTON: 'button',
    SUBMIT: 'submit'
};

export class Button extends Component {
    static propTypes = {
        btnStyle: PropTypes.oneOf(Object.values(BUTTON_STYLE)),
        btnType: PropTypes.oneOf(Object.values(BUTTON_TYPE)),
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
        fullWidth: PropTypes.bool,
        disabled: PropTypes.bool,
        'data-automation-id': PropTypes.string.isRequired
    };

    static defaultProps = {
        btnStyle: BUTTON_STYLE.NORMAL,
        btnType: BUTTON_TYPE.BUTTON,
        fullWidth: true,
        className: ''
    };

    render() {
        const { btnStyle, btnType, children, className, fullWidth, ...rest } = this.props;
        let classes = `CAPE-Button ${className} ${btnStyle}`;

        if (fullWidth) {
            classes += ' vx_btn-block';
        }

        return (
            <button
                className={classes}
                type={btnType}
                {...rest}
            >{children}</button>
        );
    }
}

export default Button;
